import { PublicClientApplication } from "@azure/msal-browser";

const msalConfig = {
  auth: {
    clientId: 'd966bff5-7ae0-4469-b481-254ee917f842', // Replace with the actual Client ID
    authority: `https://login.microsoftonline.com/8714a216-0445-4269-b96b-7d84bddb6da1`, // Replace with your Azure AD Tenant ID
    redirectUri: window.location.origin //"http://localhost:3000/", // Update this based on your app
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  }
};

export const msalInstance = new PublicClientApplication(msalConfig);